import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CollaboratorsService {
  constructor(private http: HttpClient) {}

  getCollaborators(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/collaborator/collaborators`);
  }

  getCollaboratorDetails(collaboratorId: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/collaborator/details/${collaboratorId}`);
  }

  createCollaborator(data: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/collaborator`, data);
  }

  updateCollaborator(data: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/collaborator`, data);
  }

  resendInvitationLink(data: { collaboratorId: string }): Observable<any> {
    return this.http.put(`${environment.apiUrl}/collaborator/resend-invitation-link`, data);
  }

  removeCollaborator(id: string): Observable<any> {
    const options = {
      body: { collaboratorId: id }
    };
    return this.http.delete(`${environment.apiUrl}/collaborator`, options);
  }
}
